/**
 * Constants for different types of dashboard interactions tracked by SceneRenderProfiler
 */

export const REFRESH_INTERACTION = 'refresh';
export const TIME_RANGE_CHANGE_INTERACTION = 'time_range_change';
export const FILTER_ADDED_INTERACTION = 'filter_added';
export const FILTER_REMOVED_INTERACTION = 'filter_removed';
export const FILTER_CHANGED_INTERACTION = 'filter_changed';
export const FILTER_RESTORED_INTERACTION = 'filter_restored';
export const VARIABLE_VALUE_CHANGED_INTERACTION = 'variable_value_changed';
export const SCOPES_CHANGED_INTERACTION = 'scopes_changed';
export const ADHOC_KEYS_DROPDOWN_INTERACTION = 'adhoc_keys_dropdown';
export const ADHOC_VALUES_DROPDOWN_INTERACTION = 'adhoc_values_dropdown';
export const GROUPBY_DIMENSIONS_INTERACTION = 'groupby_dimensions';
